const orderItemService = {
    duplicateItem: function (orderItem, itemDetails) {
        return Collaterate.Project.duplicateItem(orderItem, itemDetails);
    },

    updateItem: function (orderItem) {
        return Collaterate.Project.updateItem(orderItem);
    }
};
export default orderItemService;